import Hero from "../components/Hero";
import PlanTrip from "../components/PlanTrip";
import OurService from "../components/ourService";
import Banner from "../components/Banner";
import Banner2 from "../components/Banner-2";
import Navbar from "../components/Navbar";
import SEO from "../components/SEO";
import StructuredData from "../components/StructuredData";
import Testimonials from "../components/Testimonials";
import LocalHireSection from "../components/LocalHireSection";
import Faq from "../components/Faq";
 
import { faqItems } from "../data/faqItems";
import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";
import Footer from "../components/Footer";
import LoadingProgress from "../components/loadingProgress";
import locationDialogBG from "../images/banners/australia-image.jpg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { FaArrowCircleRight } from "react-icons/fa";

function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [openLocationDialog, setOpenLocationDialog] = useState(false);

  const handleWhatsAppCall = () => {
    const phoneNumber = +610400920512;
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    const handleLoad = () => {
      setLoading(false);
    };

    if (document.readyState === "complete") {
      setLoading(false);
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  useEffect(() => {
    const ipGeoLocationApiKey = process.env.REACT_APP_IPGEOLOCATION_API_KEY;
    if (!ipGeoLocationApiKey) return;

    const ipGeoLocationApiUrl = `https://api.ipgeolocation.io/ipgeo?apiKey=${ipGeoLocationApiKey}`;

    fetch(ipGeoLocationApiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch IP geolocation data");
        }
        return response.json();
      })
      .then((country) => {
        if (
          country.country_code2 !== "AU" ||
          country.country_code3 !== "AUS" ||
          country.country_name !== "Australia"
        ) {
          setOpenLocationDialog(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching IP geolocation data:", error);
      });
  }, []);

  const handleClose = () => {
    setOpenLocationDialog(false);
  };

  useEffect(() => {
    if (!openLocationDialog) return;

    const timer = setTimeout(() => {
      handleClose();
    }, 9000);

    return () => clearTimeout(timer);
  }, [openLocationDialog]);

  return (
    <>
      <SEO
        title='EZ Car Rentals | Car, Van & Ute Hire in Melbourne, Victoria, Australia'
        description='Affordable car, van, and ute rental in Melbourne, Victoria, Australia. EZ Car Rentals offers reliable vehicle hire services in Huntingdale, Chadstone, and surrounding areas. Book online today with competitive rates and flexible rental options.'
        keywords='car rental Melbourne, van hire Victoria, ute rental Australia, car hire Melbourne, vehicle rental Victoria, cheap car rental Melbourne, van hire Chadstone, ute hire Huntingdale, car rental Australia, EZ Car Rentals, car rental Huntingdale, van rental Melbourne, ute hire Victoria, car hire Australia, car rental near me Melbourne, van hire near me Victoria'
        url='https://ezcarrentals.com.au/'
      />
      <StructuredData type='localBusiness' />
      <StructuredData type='organization' />
      <StructuredData type='website' />
      <StructuredData type='faq' faqItems={faqItems} />

      <Dialog
        open={openLocationDialog}
        onClose={handleClose}
        aria-labelledby='location-dialog-title'
        PaperProps={{
          sx: {
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.89), rgba(255, 255, 255, 1)), url(${locationDialogBG})`,
            backgroundSize: "contain",
            backgroundPosition: "center",
            width: "80%",
            maxWidth: "700px",
            height: "80%",
            maxHeight: "400px",
            borderRadius: "16px",
            "@media (max-width: 600px)": {
              maxHeight: "40%",
            },
          },
        }}
      >
        <DialogTitle id='location-dialog-title'>
          <Typography
            variant='h2'
            component='p'
            color='primary'
            sx={{
              textAlign: "center",
              color: "#2d5b89",
              fontWeight: 400,
              "@media (max-width: 600px)": {
                fontSize: "40px",
              },
            }}
          >
            Oops!
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            variant='h4'
            component='p'
            sx={{
              textAlign: "center",
              mb: 2,
              color: "#011936",
              "@media (max-width: 600px)": {
                fontSize: "18px",
              },
            }}
          >
            It seems you&apos;re not in Australia.
          </Typography>
          <Typography
            variant='body1'
            sx={{
              textAlign: "center",
              color: "#465362",
              "@media (max-width: 600px)": {
                fontSize: "14px",
              },
            }}
          >
            Our services are currently available only to users in Australia. We
            hope to expand to your region soon.
          </Typography>
          <Typography
            variant='body1'
            sx={{ textAlign: "center", color: "#465362", mt: 2 }}
          >
            Thank you for visiting!
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", mb: 2 }}>
          <Button
            onClick={handleClose}
            color='primary'
            variant='contained'
            sx={{ background: "#80b918" }}
            size='large'
            endIcon={<FaArrowCircleRight />}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>

      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <LoadingProgress />
        </div>
      ) : (
        <>
          <Navbar />
          <Hero />
          <Banner />
          <PlanTrip />
          <Banner2 />
          <OurService />
          {/* <BookCar /> */}
          <Testimonials />
          <LocalHireSection />
          <Faq />
          <Footer />
          <div className='wh-api-bg'>
            <button
              type='button'
              className='wh-api'
              onClick={handleWhatsAppCall}
              aria-label='Contact us on WhatsApp'
            >
              <div className='wh-fixed whatsapp-pulse'>
                <span className='wh-ap-btn' aria-hidden='true'></span>
              </div>
            </button>
          </div>
          <div className='scroll-up-button'>
            {isVisible && (
              <button onClick={scrollToTop} aria-label='Scroll to top'>
                <FaArrowUp />
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
}

export default Home;
